module.exports = __webpack_public_path__ + "img/busca-invertebrados.ffdb33ba.jpg";